import {IconNames} from '@wandb/weave/components/Icon';
import {SmallRefLoaded} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/smallRef/SmallRefLoaded';
import {getObjectVersionLabel} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/smallRef/SmallWeaveRef';
import {WeaveObjectRef} from '@wandb/weave/react';
import React, {useMemo} from 'react';

import {useSmallRefPreferredRouter} from './common';

export const SmallOpVersionsRef = ({
  objRef,
  displayName,
}: {
  objRef: WeaveObjectRef;
  displayName?: string;
}) => {
  const router = useSmallRefPreferredRouter();

  const url = useMemo(
    () =>
      router.opVersionsUIUrl(objRef.entityName, objRef.projectName, {
        opName: objRef.artifactName,
      }),
    [objRef, router]
  );

  const label = useMemo(
    () => displayName ?? getObjectVersionLabel(objRef, -1),
    [objRef, displayName]
  );

  return (
    <SmallRefLoaded
      icon={IconNames.JobProgramCode}
      label={label}
      url={url}
      error={null}
    />
  );
};
